module.exports = __webpack_public_path__ + "static/media/report-account-2x.1695a104.png";